import { Injectable } from '@angular/core';
import { NzModalService } from 'ng-zorro-antd/modal';
import { Observable, of } from 'rxjs';
import { catchError, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ApiService } from '../common/services/api.service';
import { CommonService } from '../common/services/common.service';
import { LocalStorageService } from '../common/services/localStorage.service';
import { DateService } from '../common/services/date.service';
import { LoanDetails } from './order.interface';
import { global_app_settings } from 'src/app/constants/global-app-settings';

@Injectable()
export class LoanService {
  eligibilityApiData: any;
  restDetails: any;
  showBanner: boolean = false;
  private isModalOpen = false; // Flag to track the modal state
  constructor(
    private _modalService: NzModalService,
    private _apiService: ApiService,
    private _localStorage: LocalStorageService,
    private _commonService: CommonService,
    private _dateService: DateService
  ) {
  }

  openDifferentComponent(isSubmit): void {
    if (!global_app_settings.enable_loan_feature) {
      return;
    }
    const SEED_FLEX_URL: string =
      'https://app.seedflex.com/login?partner=EasyEat';
    if (isSubmit) {
      window.open(SEED_FLEX_URL, '_blank', 'noopener,noreferrer');
    } else {
      this.getComponent();
    }
  }

  private getComponent(): void {
    const restId = this._localStorage.get('restaurant_id') || ''
    if (restId?.length) {
      this._apiService.fetchLoanEligibility(restId).subscribe(
        (response: any) => {
          const eligibilityData =  response?.data
          this.eligibilityApiData = eligibilityData?.eligibility;
          eligibilityData?.isEligible
            ? this.eligibleFormCreate()
            : this.openLoanEligibleModal();
        },
        (error: any) => {
          console.error('API call failed:', error);
        }
      );
    }
  }

  private eligibleFormCreate(): void {
    const restId = this._localStorage.get('restaurant_id') || ''
    const formData = new FormData();
    formData.append('restaurant_id', restId);
    if (restId?.length) {
      this._apiService.getRestaurantDetails(formData).subscribe(
        (response: any) => {
          this.restDetails = response?.data;
          this.openEligibleForm();
        },
        (error) => {
          console.error('Error fetching restaurant details:', error);
        }
      );
    }
  }

  private async openEligibleForm() {
    if (!this.isModalOpen) { // Check if the modal is already open
      this.isModalOpen = true; // Set the flag to true to indicate the modal is open
      const { EligibleFormComponent } = await import(
        /* webpackPrefetch: true */ './modal/eligible-form/eligible-form.component'
      );
      const modal = this._modalService.create({
        nzClosable: false,
        nzContent: EligibleFormComponent,
        nzWrapClassName: 'eligible-form',
        nzWidth: '88vw',
        nzStyle: { top: '70px' },
        nzFooter: null,
        nzComponentParams: {
          formrestDetails: this.restDetails,
        },
      });
  
      // Reset the flag when the modal is closed
      modal.afterClose.subscribe(() => {
        this.isModalOpen = false;
        this.updateRestDetails();
      });
    }
  }

  private async openLoanEligibleModal() {
    const { EligibleDialogueComponent } = await import(
      /* webpackPrefetch: true */ './modal/eligible-dialogue/eligible-dialogue.component'
    );
    this._modalService.create({
      nzClosable: false,
      nzContent: EligibleDialogueComponent,
      nzWrapClassName: 'not-eligible-modal',
      nzStyle: { top: '50px' },
      nzWidth: '40vw',
      nzComponentParams: {
        criteria: this.eligibilityApiData,
      },
      nzFooter: null,
    });
  }

  openLoanBannerDetails(): Observable<LoanDetails | {}> {
    if (!global_app_settings.enable_loan_feature) {
      return of({});
    }
    return this._commonService.restaurantDetails$.pipe(
      filter((data: any) => !!data?.loan),
      distinctUntilChanged(),
      map((data: any) => {
        const loan = data?.loan;
        const planType = data?.settings?.global?.plan;
        const isMarked = data?.loan?.isMarked;
        const isNotApproved = data?.loan?.isNotApproved;
        const showBanner = loan?.showLoanBanner && loan?.loanLimit > 0;
        const today = this._dateService.formatDate(new Date());
        const formSubmittedAt = this._dateService.formatCollectionDate(
          loan?.formSubmittedAt,
          'DD MMM YYYY'
        );

        const isFormSubmittedRecently = formSubmittedAt === today;
        return { showBanner, isFormSubmittedRecently, loanLimit:loan?.loanLimit, isSubmit:loan?.formSubmitted , planType ,isMarked, isNotApproved};
        
      }),
      catchError((error) => {
        console.error('Error fetching restaurant details:', error);
        return null;
      })
    );
  }
  private updateRestDetails() {
    const restId = this._localStorage.get('restaurant_id') || ''
    const formData = new FormData();
    formData.append('restaurant_id', restId);
    if (restId?.length) {
      this._apiService.getRestaurantDetails(formData).subscribe(
        (response: any) => {
         this._commonService.setRestaurantDataObs(response?.data)
        },
        (error) => {
          console.error('Error fetching restaurant details:', error);
        }
      );
    }
  }
}
